export default __webpack_public_path__ + "static/media/ic_ios_add.87725351.svg";